import { Link } from "react-router-dom";
import { ArrowRight, Home, Phone } from "lucide-react";
import { site } from "@/config/site";
import { SEO } from "@/lib/seo";

export default function NotFound() {
  return (
    <>
      <SEO title="Page Not Found | North Ember Painting" description="The page you're looking for doesn't exist. Explore North Ember Painting's services, projects and estimates." path="/404" />
      <section className="flex min-h-[70vh] items-center bg-ink texture-grain py-20" data-testid="not-found-page">
        <div className="mx-auto max-w-2xl px-4 text-center sm:px-6">
          <p className="font-display text-7xl font-extrabold tracking-tight text-ember sm:text-8xl">404</p>
          <h1 className="mt-4 font-display text-3xl font-bold tracking-tight text-slate-50 sm:text-4xl">
            This wall hasn't been painted yet
          </h1>
          <p className="mx-auto mt-4 max-w-md text-base leading-relaxed text-slate-400">
            The page you're looking for doesn't exist or has moved. Let's get you back to solid ground.
          </p>
          <div className="mt-9 flex flex-col justify-center gap-3 sm:flex-row">
            <Link
              to="/"
              data-testid="not-found-home-btn"
              className="inline-flex min-h-[48px] items-center justify-center gap-2 rounded-full bg-ember px-7 py-3 text-sm font-semibold text-white transition-[background-color,transform] duration-300 hover:-translate-y-0.5 hover:bg-ember-dark"
            >
              <Home className="h-4 w-4" aria-hidden="true" /> Back to Home
            </Link>
            <Link
              to="/estimate"
              data-testid="not-found-estimate-btn"
              className="inline-flex min-h-[48px] items-center justify-center gap-2 rounded-full border border-slate-600 px-7 py-3 text-sm font-semibold text-slate-100 transition-colors duration-200 hover:border-ember"
            >
              Get a Free Estimate <ArrowRight className="h-4 w-4" aria-hidden="true" />
            </Link>
            <a
              href={site.phoneHref}
              data-testid="not-found-call-btn"
              className="inline-flex min-h-[48px] items-center justify-center gap-2 rounded-full border border-slate-600 px-7 py-3 text-sm font-semibold text-slate-100 transition-colors duration-200 hover:border-ember"
            >
              <Phone className="h-4 w-4 text-ember" aria-hidden="true" /> {site.phone}
            </a>
          </div>
        </div>
      </section>
    </>
  );
}
